import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import injectLanguage from 'src/components/LanguageWrapper/inject'
import EventsService from 'src/utils/events-service'
import Dropdown from 'src/components/Dropdown'
import { Icon } from 'antd'
import SvgIcon from 'src/components/SvgIcon'
import Avatar from 'src/components/Avatar'
import Menu from 'src/components/Menu'
import { isFeatureUsed } from 'src/utils/features'
import { getBodyContainer, hasFeatureFlag, isEmpty } from 'src/utils/helpers'

import { WidgetContext } from 'src/modules/App/WidgetContext'

import styles from './dropdown.module.less'

class HeaderDropdown extends PureComponent {
  componentDidMount() {
    const {
      refKey,
      dropdownsVisibility,
      setDropdownVisibility,
    } = this.props

    // Close all "other" dropdowns
    if(!isEmpty(dropdownsVisibility) && Array.isArray(Object.keys(dropdownsVisibility))) {
      const otherDropdowns = Object.keys(dropdownsVisibility)
        .filter(key => key !== refKey)
        .reduce((obj, key) => {
          obj[key] = false
          return obj;
        }, {});

      setDropdownVisibility(otherDropdowns)
    }
  }

  changeLanguage = (language) => () => {
    const {
      setLanguage,
    } = this.props

    // Change language
    setLanguage(language)
  }

  pageReset = (e, isOnLink = false) => {
    const { closeSidebar, setCurrentlyOpenFeature, areAppActionsDisabled } = this.props

    // Prevent these actions if disabled globally
    if (e && areAppActionsDisabled) {
      e.stopPropagation()
      e.preventDefault()

      return false
    }

    if(isOnLink && e) {
      e.stopPropagation()
    }

    if (typeof closeSidebar === 'function') {
      closeSidebar()
    }

    if (typeof setCurrentlyOpenFeature === 'function') {
      setCurrentlyOpenFeature('')
    }
  }

  getPopupContainer = () => {
    return getBodyContainer()
  }

  menuItemLanguageEn = () => {
    return (
      <Menu.Item onClick={this.changeLanguage('en')}>
        <FormattedMessage
          // This ID can't contain variable because of translation
          id="app.header.links.language.en"
          defaultMessage="English"
        />
      </Menu.Item>
    )
  }
  menuItemLanguageFr = () => {
    return (
      <Menu.Item onClick={this.changeLanguage('fr')}>
        <FormattedMessage
          // This ID can't contain variable because of translation
          id="app.header.links.language.fr"
          defaultMessage="French"
        />
      </Menu.Item>
    )
  }

  menuSubItemLanguages = () => {
    const languageMenuTitle = (
      <FormattedMessage
        id="app.header.links.languageTitle"
        defaultMessage="Language"
      />
    )

    return (
      <Menu.SubMenu title={languageMenuTitle} className="menu-sub-items-languages">
        {this.menuItemLanguageEn()}
        {this.menuItemLanguageFr()}
      </Menu.SubMenu>
    )
  }

  menuItemClose = () => {
    const { isWidget, handleCloseWidget } = this.props

    return (
      <Menu.Item display-if={isWidget} onClick={(e) => {

        // Basically just to re-render and hide the dropdown
        this.pageReset(e)

        handleCloseWidget()
      }}>
        <FormattedMessage
          id="app.header.links.close"
          defaultMessage="Close"
        />
      </Menu.Item>
    )
  }

  renderDropdownMenu = () => {
    // This needs to return a Menu component (https://ant.design/components/dropdown/)
    const DefaultResponse = <Menu />

    try {
      const {
        user,
        featureFlags,
        countryIsoCode,
        isLanguageMenu,
        isWidgetState,
        features,
        labels,
      } = this.props


      if(isLanguageMenu) {
        return (
          <Menu getPopupContainer={this.getPopupContainer} className={styles.contentLanguage}>
            {this.menuItemLanguageEn()}
            {this.menuItemLanguageFr()}
          </Menu>
        )
      }

      if (this.isLoggedOut()) {
        return (
          <Menu getPopupContainer={this.getPopupContainer}>
            {this.menuItemClose()}
             <Menu.Item onClick={this.pageReset}>
              <Link to="/auth/login" className={styles.link}>
                <FormattedMessage
                  id="app.header.links.login"
                  defaultMessage="Login"
                />
              </Link>
            </Menu.Item>
            {this.menuSubItemLanguages()}
          </Menu>
        )
      } else {
        // TODO: Figure out better way to disable these actions for sub-users
        const isSubUser = user && user.hasOwnProperty('vuaId') && user.vuaId

        // If push feature flag is used and feature is enabled in settings
        const hasPushChat = hasFeatureFlag(featureFlags, 'push.chat')
          && isFeatureUsed('chat', features, labels)
        const hasPushDocs = hasFeatureFlag(featureFlags, 'push.documents')
          && isFeatureUsed('documents', features, labels)

        return (
          <Menu getPopupContainer={this.getPopupContainer}>
            <Menu.Item onClick={this.pageReset}>
              <Link to="/user/profile" className={styles.link}>
                <FormattedMessage
                  id="app.header.links.profile"
                  defaultMessage="Profile"
                />
              </Link>
            </Menu.Item>
            {!isWidgetState && (hasPushChat || hasPushDocs) ? (
              <Menu.Item onClick={this.pageReset}>
                <Link to="/user/notifications" className={styles.link}>
                  <FormattedMessage
                    id="app.header.links.notifications"
                    defaultMessage="Notifications"
                  />
                </Link>
              </Menu.Item>
            ) : ''}

            {/* Show users link if feature flag is received from backend */}
            {hasFeatureFlag(featureFlags, 'users.manage.viewAddRemove') && !isSubUser ? (
              <Menu.Item onClick={this.pageReset}>
                <Link to="/users" className={styles.link}>
                  <FormattedMessage
                    id="app.header.links.users"
                    defaultMessage="Users"
                  />
                </Link>
              </Menu.Item>
            ) : ''}

            {/* Show if feature flag is received from backend */}
            {hasFeatureFlag(featureFlags, 'pages.contact') ? (
              <Menu.Item onClick={this.pageReset}>
                <Link to="/contact" className={styles.link}>
                  {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
                    <FormattedMessage
                      id="app.header.links.myAgent"
                      defaultMessage="My Agent"
                    />
                  ) : (
                    <FormattedMessage
                      id="app.header.links.myBroker"
                      defaultMessage="My Broker"
                    />
                  )}
                </Link>
              </Menu.Item>
            ) : ''}

            {this.menuSubItemLanguages()}

            {this.menuItemClose()}

            <Menu.Item onClick={this.logout}>
              <FormattedMessage
                id="app.header.links.logout"
                defaultMessage="Logout"
              />
            </Menu.Item>
          </Menu>
        )
      }
    } catch (e) {
      return DefaultResponse
    }
  }

  logout = async () => {
    const { userLastAccessType, resetUser, resetApp, isWidget, history } = this.props

    const logOutEventType = userLastAccessType === 'logInAsKioskUserLink' ? 'logOutAsKioskUser' : 'logOut'

    await EventsService.registerEvent({ isWidget: isWidget }, 'access', logOutEventType)

    resetUser()
    resetApp('logOut', isWidget, history)
  }

  isLoggedOut = () => {
    try {
      const { user } = this.props
      return isEmpty(user)
    } catch (e) {
      return true
    }
  }

  /**
   * Check if current dropdown is visible based on global (redux) state
   *
   * @return {boolean}
   */
  isCurrentVisible = () => {
    try {
      const { refKey, dropdownsVisibility } = this.props

      if(!isEmpty(dropdownsVisibility) && dropdownsVisibility.hasOwnProperty(refKey)) {
        return dropdownsVisibility[refKey]
      }

      return false
    } catch (e) {
      return false
    }
  }

  render() {
    const {
      refKey,
      user,
      isLanguageMenu,
      isLoggedInUserMenu,
      isLoginLink,
      hideOnDesktop,
      hideOnMobile,
      dropdownsVisibility,
      setDropdownVisibility,
      areAppActionsDisabled,
    } = this.props

    // Exit if we only need logged in user dropdown menu (Profile/Logout)
    if (this.isLoggedOut() && isLoggedInUserMenu) {
      return ''
    }

    const responsiveClassNames = cx({
      [styles.hideOnDesktop]: !!hideOnDesktop,
      [styles.hideOnMobile]: !!hideOnMobile,
    })

    // Get visibility of this dropdown in global (redux) state
    const isVisible = this.isCurrentVisible()

    const dropdownProps = {
      className: responsiveClassNames,
      overlay: this.renderDropdownMenu,
      placement: "bottomRight",
      getPopupContainer: this.getPopupContainer,
      trigger: ['click'],
      key: refKey,
      visible: isVisible,
      onVisibleChange: (newIsVisible) => {

        // Prevent dropdown interaction if disabled globally
        if (areAppActionsDisabled) {
          return false
        }

        // Update visibility of this dropdown in global (redux) state
        setDropdownVisibility({
          ...dropdownsVisibility,
          [refKey]: newIsVisible,
        })
      },
    }

    if(isLanguageMenu) {
      return (
        <Dropdown {...dropdownProps}>
          <span className={styles.trigger}>
            <span className={styles.triggerLanguage} data-qa="dropdown-trigger-language">
              <Icon className={styles.triggerLanguageIcon} type="global" />
              <span className={styles.triggerLanguageText}>{this.props.language.toUpperCase()}</span>
              <SvgIcon className={styles.triggerLanguageArrowIcon} type="RightArrow" />
            </span>
          </span>
        </Dropdown>
      )
    }

    if(isLoginLink) {
      if(this.isLoggedOut()) {
        return (
          <span className={responsiveClassNames}>
            <Link to="/auth/login" onClick={e => this.pageReset(e, true)} className={styles.link} data-qa="header-link-login">
              <SvgIcon type="FaSignInAltSolid" className={styles.loginLinkIcon} />
              <span className={styles.loginLinkWithIconText}>
                <FormattedMessage
                  id="app.header.links.login"
                  defaultMessage="Login"
                />
              </span>
            </Link>
          </span>
        )
      } else {
        return ''
      }
    }

    return (
      <Dropdown {...dropdownProps}>
        <span className={styles.trigger}>
          {this.isLoggedOut() ? (
            <SvgIcon type="Dots" size="sm" data-qa="header-trigger-default header-trigger-default--logged-out" />
          ) : (
            <Avatar data-qa="header-trigger-default header-trigger-default--logged-in">
              {user.email.charAt(0).toUpperCase()}
            </Avatar>
          )}
        </span>
      </Dropdown>
    )
  }
}

const HeaderDropdownContext = (props) => (
  <WidgetContext.Consumer>
    {context => <HeaderDropdown { ...props } { ...context } />}
  </WidgetContext.Consumer>
);


export default injectLanguage(HeaderDropdownContext)
